var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.18935 22.5271C7.57438 22.5271 7.88651 22.215 7.88651 21.83C7.88651 21.4449 7.57438 21.1328 7.18935 21.1328C6.80432 21.1328 6.49219 21.4449 6.49219 21.83C6.49219 22.215 6.80432 22.5271 7.18935 22.5271Z",
    fill: "#1098F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18935 22.5271C7.57438 22.5271 7.88651 22.215 7.88651 21.83C7.88651 21.4449 7.57438 21.1328 7.18935 21.1328C6.80432 21.1328 6.49219 21.4449 6.49219 21.83C6.49219 22.215 6.80432 22.5271 7.18935 22.5271Z",
    stroke: "#4AA459"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3354 23.4856V0.435726C14.3354 0.17429 14.1611 0 13.8997 0H0.435726C0.17429 0 0 0.17429 0 0.435726V23.4856C0 23.7471 0.17429 23.9214 0.435726 23.9214H13.8561C14.1175 23.9214 14.3354 23.7471 14.3354 23.4856ZM13.4639 0.871452V19.6948H0.871452V0.871452H13.4639ZM0.871452 23.0499V20.5663H13.4204V23.0499H0.871452Z",
    fill: "#1098F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3354 23.4856V0.435726C14.3354 0.17429 14.1611 0 13.8997 0H0.435726C0.17429 0 0 0.17429 0 0.435726V23.4856C0 23.7471 0.17429 23.9214 0.435726 23.9214H13.8561C14.1175 23.9214 14.3354 23.7471 14.3354 23.4856ZM13.4639 0.871452V19.6948H0.871452V0.871452H13.4639ZM0.871452 23.0499V20.5663H13.4204V23.0499H0.871452Z",
    stroke: "#4AA459"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/Mobile.45882f97b36cbd749ab67e0ee10d1b78.svg";
export { ForwardRef as ReactComponent };